var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('LoadingContainer'):_c('div',[_c('FormLayout',{attrs:{"headline":"Create Job","errors":_vm.errors,"company-id":_vm.portalCompany.attributes.company_id,"content-job-regions":_vm.contentJobRegions,"portal":_vm.portal,"initial":_vm.initial},on:{"submit":_vm.submit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }